import { StandardCSSProperties } from '../types.js';
import { MUI_SPACING } from './constants.js';
import { stringOrNumberDefined } from './string-or-number-defined.js';

export function sizingHelper(prop: keyof StandardCSSProperties): (
  value: string | number,
) => {
  className?: string;
  style?: StandardCSSProperties;
} {
  return (value) =>
    stringOrNumberDefined(value, prop, (val) =>
      val > 1
        ? {
            style: {
              [prop]: `${val * MUI_SPACING}px`,
            },
          }
        : {
            style: {
              [prop]: `${val * 100}%`,
            },
          },
    );
}
